export class Config {
  public static TRANSLATION_LANGS = ['English', 'French', 'Spanish'];
  public static PASSWORD_POLICY_PATTERN =
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])(?!.*?[\s]).{8,20}$/;
  public static PHONE_NUMBER_PATTERN = /^(\d{3}?)-(\d{3}?)-(\d{4}?)/;
  public static NAME_PATTERN = /^[0-9a-zA-Z\s]{2,30}$/;
  public static HISTORY_ON_ONE_PAGE = 10;
  public static HOMES_TOP = 10000;
  public static DefaultCaptcha = '03AL8dmw-6itw6TsIxzSfnELEBOK0oVhtgjdTXjWts5FJgj2e7l5InBPwmAcWIJYUapa3l7LJZa0S5EDg349QdaUCvmUNgZ83KVMTaESIngxIpX1rin7ezXgItikf_WGOGg7c_qQ_9hcm_pTlAE-7fhCRqbD-t8mPwefSM2LMIwJVLag-lmBPEgi-KNq6x7gpPcmpJ47p7PjMcaMxgnLNQczgkVoiRWJ9U4A_KZMtV-mQRt23byqyWs6MCAockOs5OTrVUpvUv3RD81JqeEmx2xkBAW1fZXScmjC5XsMeMVpKaX0DnckhiVYJEN0VZzoCe4UEl7wPVdbyivkxWzWW2MIUfFa_cxC_Zzsk-bN3VClwSkjexfJ0BZEHyLGdXGNU60UoAVX2KpOAQmoPM2-kbWiKzJdhM2gdz2eCabscxjGFOviayTy5wI8TCy9_Wp270o3H7TU-V_6p4xfj1SB8zy-kKs7i2NwF5Jr8aQ43imGdSEpeUNJ4Z2eE9bU1vhqsSIyWHBZd9MB33HnhCmTt0mldzUY5D-ybLTIuyJRcCqYG6aYjA0A7uXbI183YVVH9gJayAIZZ-kTLWCxg-FiNlOxEbiwdx4t7yAuNXLlCW1xHQ-z3OoUcnjKWD8GkXA4j_ahs6S85SCOaPAPstYNQR82fWoUtcLjEH37_xnT4234JOCXJ2SksJxzVE6YmLOuKeWBwi5tZvm4o6rhtkOOs-3Cbf8_SGqKt3QiJPKfEEoCModXzamyLXvYgQAczJ-LbonCi8oXxMiohtgldONjG5e5AnmeGQ7f0pT-9rNlwDF1sEbr2ksanOSL0EFqqp7Er5IYU365sg__X0aJ8Cpn7Ixvi7eQKBuSoeArO_h6_54HI-Jl6ozIdBUn0P48ysPNIag2Xv-OFQaMcdwLiBZ0GnNDT6HwGoRCHC1nxeM-TAe1Nov3myrSiWf8hrhk3mLoCCs7gd2cZNluSCm2a_Hk-3snfPUlPT_pCH7Apig2GqaCWniztzUK1qHaLNUmQzVO_H_TtN79tKcB65LjCbY07u_lkuTBUPnfIJyUL2DEq2ETVAsiY6M0GC7R8mNHBFQNzDlyMZIoQZQrRmzRVL_hZpKOvu8sSWaR8dXQDcS-d_GEXBix1ouKlUVoxVeuTiHUMMuSPx9G7SMsVT5IOOyJh29QDtvBnUZVFICWhJ8WPDgFOK3cVDwrO4qNTa3BBc2DUMuiM0E7Oc0RvntCdR1BdVfAYU-Mjs2m4DHbbRExC2mKVZDyaguF0yBA5lOo6qWlc8NJyf7a-GmsnD9Nu48sCfk6bgL4hBqyfIsdXZMpZpObBbnLjXR10TP9yvZk57ySllelxOpq61KFDQRnb1F25sTbreZMWHZ0dR2NZASjob42ud-Cyj0c_SXEoQQaN1MLaHgH9v9YuVl28NWpDE5IJxHDlHX60XnoT1YmDsa13F91gxDALJ92_6d1Y0PI1WAKoF4Hq9ILWLyfe01RRqwQG4N0VR0UEvXoGDhend9RX6nHfbwOiWxh4fIefHjKwdlkicKxJjUq5DkvRM3-GqGER0DO2EpQNaEjFLtgGwhiRCFijlxypooQjgBcHKHRzf9V3XHDh49CE_ATnyKxWnevgaXjWAzLF3t_t3oC3YBqyutuL2yWO_2UxuUDiQRjQh2TGgzK-12quWcZGDvJihO_bawhnAepU7-04TzMqAIwmh3u_DyPilwh1SQ713X4dJE0Una5E6Mq_wsp8WNnruZ8BM_2_5LhhVCbwEvNe9VUZb2mysfTfxdGzzzRoG1uKnYe2SiCv_-eog8dI9b8KvqaOGdAQ5g8d1HXorzOTmHsErlN94Pa8prr61bi_8_H1RANH4BofVR2qsDMM0CQIu8wTEoThbyOmsX8dNjYL2XRUTTnsHxYL-Bde4XMi3uCAFxSXDZsKFCScauWemrAl7d0UGUmywfIGt-Pc40GtGdNlHJPj8f_uGRXLuzmxIFCjXXWw9Oe_7fCZhXdCahnMWX_cxorO53PGldEhaR-pOTAN3G1qwEgW1s26v42SCkm2NEZozdo1v18G6FOJ8TOrw0kwy-aemLAmTLyg-0oM0-C_zx_Q5Ca5KiugmIZaVklLima23eQszWYX5NuWoP0nkL4eUUPaWv9JRpxpN2C3l9gYpCgjE-QcuhknE8qTWYquMQwhlUVkdogtcM_ZlHp0_RiT2tqtGEOMqMO_-aiq-RfwtiwaFCpRLFLkU4T7-iVhTEEFy18OiUaRnLD1mS5CgkaWLaeeCygzSO-Zd6TX7wSABH647PujKlnCEnG37UOjRZoHdVkI3RCMDWiynAzCE1uUlCiUDK8sfe1acx2zmc-dNvaF88ewAiqrk9gyLMthKqWHtgpBDqmYFbmwg7V8I2abLz7wJRqqZlbctGBiuwZdonEEdRA93h6cJQj2kCJAggoN9ERrM50tFj3neooTqvv9oaPQ3DGoYCOCJb10j3jzHAuce0_qOm-OBrbDKi7Gw33SMYxhyiYByfCg9H6Y1KlipdjxVYftOWfaowwsPdOqbikwI9rAOA04tImzUrOnF2Bjxa1oJ51l4ElPZql2A3pcoLhloFAP062lqh61GgvnuvxzVHcmkz8z5p54_kmT6Dec3I1RmpghnlU6_LI-pxsOWhPiZwt4sY5Sko17xDmsFDQIbIUljLSNPKU13bua35cuMyTfYt2fs7zf7BM5BkeFWX-EHtuQfhfGjDMyeyXShePC2dNP_38ylTVNKknGie3lpTNxpNmZwOGqopcDsPqyXy3LUOBsF5XNkxYmrlyOGtOliA0MVZkH-zO3f2VfPZUM4qZbzo14ux9gSz9anp6ge3fCLf0tVXFORClgXIwfktrebYAS17-nNwrHsytoZxTtihYOpDmOXcYp6IR8BYR_K6l7JkKTqDh9wim-WBO3-xn631pwtZ8vnyHBahK4RTi26jnlpTbB7FmrkHBmYcidTUSA0So8QHVK5cScNR1WP72851r4GeTt4aBAwBhLrSh_uL06I0l4cFp-yoZkZd0CzslT6FdDvKKSlgcm2nNXyKXZ2INDXS7nYy0o-e9dsyEVEOqQIDx_6doadqGUVR1Qmwr_Ow-NPAVlhgyqbOMgUOrXN6vyKX7OQMwv2G88lijqG8gvhZEx9HfTFwS__cdE2LK9zis1PrvGK2pr7UURtJ9LycO1eLLKCv3lY8BgHaRNiFg_0sXyN7se0U8T8Sh67D85PyVC8wekfVCN6985-kBDTtKbcb7Z4ICb4TE9Fw60EZYr2Dpt6kemwj685UHwyS3giISWgH4nY7N3_-OrCOxxoUjWtY7JEu8Rguom__w7eLG5xirYe0-RATuc2pmrwLIQguT3D9hXV3sutFyKLm_Ha986n-kcvnXTNSW1Lybe0abiQe8mCHqar4QrYXbOeCsRqI031OhzAN-GAHF6zJ2WBEmMnkI70hbcVAt5zyo3KmBYNAgFHFWw9fAbGgSdY7SMJYRr3tosIQMo8P8opwkIQ93oGqQUDUyDFa2zzlNalPidK4PuKMlsyg39ilyTra9fQI4tzs1TxodMbsdGm5Kk1JdZcqNowPiNXRpNRL_yrHlrrdBaomY_HzSdMKePQwJs7hssZ3r3G7vY1HLe-glXyfPNsemy3yh_RtBLOBrOLqwpiwL-9bdGuLpU5r1n7pArW0BDlhKvGmAPzS__dXUo_8HiNIOpcxnKUngCc3DOomluJHjdCWk3Pr0N4QlF2vymvrF-qbqLCr_bpMU8iJ6JCPxj15PWCYJttDYDldwXnWqqvl0JfmSK1DccumzdDh5cI0uwxXF-0SnvR923AgmVSDELP4pe62-pUpjlRnq7ChEMyy-QHoLqCAVkrAwaPXcGbcS2UOTOf6dVlnb85QBc7BOL4WfD8Nnw8OHpQmtSrwilSlbSDmx6HLmy5EGAIWd6iKvj4W-lFGYecKWEQEI_8k0jkP-YOQ2archQAgRdw2Z9XOTKFGPwnh0xP9At7wHxhO_WgEcewhJd953c-8uX-y8EbZ9vkeEzt858hSzHKisM4H2fSDard2MbtR7Dx3KOlpLoQqTJF2iyqLh4iOjHVfVApQXDlv1vVD_LD2mKhupoDk4Fja7S9WCyE9x42qpGiJ9Rr1zUWQYMUmNo5Tj1V5bVPle1VSo52CeQRFSEOqfV7xgMk4pgNomMsRIuolGlR1vEslq5IYgkb9oWZZgsuhUPHlEzLzM9OZsRJW8JECALcBVXsU9q8PMKXRw4CsZmdROtTVKztZCMfDFVugQHlR_aBX7k8AgRJBTsHgpaDGAPA8FYb6P3DSTdDURKEG543CH8v6gui1HN0HKkUpcz2OjaH2GjcfiQ0Cwzmj9dueX0yliW08vGjoJST64oWckJSCzxWgy5igB7Pi9c8l4LxQOzAzDcbVvEA0wsTV-BM91bjXUJu7vE_Gr9qxRTGdds9NnU6Dv48NPf-4wMm4RR3kNCV4IxadxiDJs8Xq7yKMCsbP_jaSl7bGrQD5uEGhYcguVDe9czhVUNVO_C_aCjx1jpCORTC0dyWDrp3zY2QkDsMBXPRriDsIP0t7ixl0MR3rQHA98ZBor2TxwkLwYdpUmqPamA3uO-qn7DiIGsK7fW70dWY3nqL0UVoivIJi-QXz6FiDUzoFQYR5xNFhswMwSAWFw_25SzPLqzNv9cz_9DAi86Gzykq8IZcy3SVWvCCxk3jqxnKYqXhiyU9-fTDPqua4iCtEf0YemceuUp8hp7FbTBVV4y19qhG05MpFlZ_8lpZpqqWybL7SC1CbkreaLfHKiW0-xMBsvwZsDGc9lCGc4rKZyZUlozmetL8Y4V7fZEKo8tWRRycIpgJSS55N9pEB4PO9u_A2va9MwG6-fEeezUMnw0LI3Gua815_juxPxtw_sE0adxHbn4G3uaycDUP0xmhJHtFSIy1E03s-hWr8NIbQhBfSUh8XYcSETngOGI2wjXNiapbbuQZuU9AR8Cu_YlmOm-Yb1vvEx5vLUBa38IGRWqYdCCXV_y0FBlsk1hsHSEFuyZwxIZ_xhtomWgDGaxAScPPyci-RDVNne69G4GobosFBIeWVrQrqn94PTMcMjw626IynG-cRFBVVDk_Ko45Ea_-kzchqZLK-RrmMQ-OZC-YnSs3pYKaPxe-NONBfF0OUlFSmSDFbEcUCq_MK-bMn2ajHxcuZS4fUOKn8lYPaCg6yK7adr0mUrvuOHNf_Jyq2pTAdwComL5cQkGUPlrmKQqmbnCGUP0cCyxJWfanoy8N-_jebSf8gYe2EbhUt8hemYA2KxWME74_f40H39A-gOKvPgkT1LymMul8dM-vAa0jnciLg-2U7gYOkeONe46bkS15jWQvNrBD45NksE_gHZ0HyrCjWAVhPs2TTPbh4q6FL_r9ybSGQS1B8As_1pBYSNseyhvNOxm83ENCZC_8uQ5XBcj9eSeyVR1xiimTBidAWjw5Pz1NjjU4OWyx9RuiPt1wEBmWsho0R9kCec99vORGXYZa95rfPhzQ1FXBHKAoudXCjj3S1_9QNd5d2h5P6LnC964WH8n6Ysk53xWQ-i8q5Gv98gc0zGyeklY-VbjbeNlHZFXw4M-uxi0_XDZ4rcO7xDfZYMma74ga73647Qra8zkHMrUHJOYPZbVibE0B'
  public static USER_ACCESS_STATUSES = [
    {
      'en-us': 'Pending',
      fr: "En'attente",
    },
    {
      'en-us': 'Enabled',
      fr: 'Activé',
    },
    {
      'en-us': 'Disabled',
      fr: 'Handicapé',
    },
    {
      'en-us': 'Cancel',
      fr: 'Annuler',
    },
  ];
  public static ACCESS_LEVELS = [
    {
      'en-us': 'Admin',
      fr: 'Administrateur',
    },
    {
      'en-us': 'Guest',
      fr: 'Invité',
    },
  ];
  public static USER_STATUSES = [
    {
      'en-us': 'Enabled',
      fr: 'Activé',
    },
    {
      'en-us': 'Disabled',
      fr: 'Handicapé',
    },
    {
      'en-us': 'Pending',
      fr: "En'attente",
    },
  ];
  public static HISTORY_CHECKLISTS = [
    {
      'en-us': 'Activation',
      fr: 'Activation',
    },
    {
      'en-us': 'Jammed',
      fr: 'Coincé',
    },
    {
      'en-us': 'Locked',
      fr: 'Fermé à clé',
    },
    {
      'en-us': 'Unlocked',
      fr: 'Débloqué',
    },
    {
      'en-us': 'Low Battery',
      fr: 'Batterie faible',
    },
    {
      'en-us': 'Very Low Battery',
      fr: 'Batterie très faible',
    },
    {
      'en-us': 'Too Low to Operate',
      fr: 'Trop bas pour fonctionner',
    },
    {
      'en-us': 'Out of schedule access attempted',
      fr: "Tentative d'accès hors programme",
    },
    {
      'en-us': 'Invalid access limit exceeded',
      fr: "Limite d'accès invalide dépassée",
    },
    {
      'en-us': 'Key Pad / Touch Screen Tamper',
      fr: 'Clavier/écran tactile anti-sabotage',
    },
    {
      'en-us': 'Forced Entry',
      fr: 'Entrée forcée',
    },
    {
      'en-us': 'Changed Wi-Fi Credentials',
      fr: 'Identifiants Wi-Fi modifiés',
    },
    {
      'en-us': 'Unknown',
      fr: 'Inconnue',
    },
    {
      'en-us': 'History Cleared',
      fr: 'Historique effacé',
    },
    {
      'en-us': 'Door Open',
      fr: 'Porte ouverte',
    },
    {
      'en-us': 'Auto Locked',
      fr: 'Verrouillage automatique',
    },
    {
      'en-us': 'Auto Unlocked',
      fr: 'Déverrouillage automatique',
    },
    {
      'en-us': 'Removed BLE Pairing',
      fr: 'Couplage BLE supprimé',
    },
    {
      'en-us': 'Added BLE Pairing',
      fr: 'Couplage BLE ajouté',
    },
    {
      'en-us': 'Completed Successfully',
      fr: 'Complété avec succès',
    },
    {
      'en-us': 'Unsuccessful',
      fr: 'Infructueux',
    }
  ];
  public static SOURCES_CHECKLISTS = [
    {
      'en-us': 'Mobile (Wifi, LTE, ETC)',
      fr: 'Mobile (Wifi, LTE, ETC)',
    },
    {
      'en-us': 'Manual (Turn Piece, Key)',
      fr: 'Manuel (tourner la pièce, clé)',
    },
    {
      'en-us': 'Keypad',
      fr: 'Clavier',
    },
    {
      'en-us': 'Battery Alarm',
      fr: 'Alarme de batterie',
    },
    {
      'en-us': 'General Info',
      fr: 'Inform générales',
    },
    {
      'en-us': 'Unknown Source',
      fr: 'Source inconnue',
    },
    {
      'en-us': 'BLE',
      fr: 'BLE',
    },
    {
      'en-us': 'Fingerprint',
      fr: 'Empreinte digitale',
    },
    {
      'en-us': 'Alexa',
      fr: 'Alexa',
    },
    {
      'en-us': 'Google Home',
      fr: 'Google Home',
    },
    {
      'en-us': 'Network',
      fr: 'Réseau',
    },
    {
      'en-us': 'Access Alert',
      fr: 'Alerte de acces',
    },
    {
      'en-us': 'Auto Lock',
      fr: 'Verrouillage automatique',
    },
    {
      'en-us': 'Tamper Alarm',
      fr: 'Alarme de sabotage',
    },
    {
      'en-us': 'Device Activation',
      fr: "Activation de l'appareil",
    },
    {
      'en-us': 'Device Deactivation',
      fr: "Désactivation de l'appareil",
    },
    {
      'en-us': 'Door open for extended period of time',
      fr: 'Porte ouverte pour période prolongée',
    },
  ];
  public static BATTERY = {
    NORMAL: 'Normal Operating State',
    LOW: 'Low Operating State',
    VERY_LOW: 'Very Low Operating State',
    TOO_LOW: 'Too Low to Operate State',
  };
  public static BATTERY_STATUS_LIST = [
    {
      'en-us': 'Normal Operating State',
      fr: 'État de fonctionnement normal',
    },
    {
      'en-us': 'Low Operating State',
      fr: 'État de fonctionnement bas',
    },
    {
      'en-us': 'Very Low Operating State',
      fr: 'État de fonctionnement très faible',
    },
    {
      'en-us': 'Too Low to Operate State',
      fr: 'État trop bas pour fonctionner',
    },
  ];
  public static PRODUCTS_LIST = [
    {
      'en-us': 'Biometric Lock',
      fr: 'Serrure biométrique',
    },
    {
      'en-us': 'LC BLE Lock',
      fr: 'LC BLE Bloquer',
    },
    {
      'en-us': 'Wi-Fi Lock',
      fr: 'Wi-Fi Bloquer',
    },
  ];

  public static SECURITY_QUESTIONS = [
    {
      'en-us': 'What was your childhood nickname?',
      'fr': 'Quel était votre surnom quand vous étiez enfant ?'
    },
    {
      'en-us': 'What is the name of your favorite childhood friend?',
      'fr': "Quel est le nom de votre ami d'enfance préféré ?"
    },
    {
      'en-us': 'In what city or town did your mother and father meet?',
      'fr': 'Dans quelle ville ou village votre mère et votre père se sont-ils rencontrés ?'
    },
    {
      'en-us': 'What is the middle name of your oldest child?',
      'fr': 'Quel est le deuxième prénom de votre enfant aîné ?'
    },
    {
      'en-us': 'What is your favorite team?',
      'fr': 'Quelle est votre équipe préférée ?'
    },
    {
      'en-us': 'What is your favorite movie?',
      'fr': 'Quel est votre film préféré ?'
    },
    {
      'en-us': 'What was your favorite sport in high school?',
      'fr': 'Quel était votre sport préféré au secondaire ?'
    },
    {
      'en-us': 'What was your favorite food as a child?',
      'fr': 'Quel était votre plat préféré quand vous étiez enfant ?'
    },
    {
      'en-us': 'What is the first name of the boy or girl that you first kissed?',
      'fr': 'Quel est le prénom de la personne que vous avez embrassée pour la première fois ?'
    },
    {
      'en-us': 'What was the make and model of your first car?',
      'fr': 'Quels étaient la marque et le modèle de votre première voiture ?'
    },
    {
      'en-us': 'What was the name of the hospital where you were born?',
      'fr': "Quel était le nom de l'hôpital où vous êtes né ?"
    },
    {
      'en-us': 'Who is your childhood sports hero?',
      'fr': 'Qui est votre héros sportif de jeunesse ?'
    },
    {
      'en-us': 'What school did you attend for sixth grade?',
      'fr': 'Quelle école avez-vous fréquentée en sixième année ?'
    },
    {
      'en-us': 'What was the last name of your third grade teacher?',
      'fr': 'Quel était le nom de famille de votre professeur de troisième année ?'
    },
    {
      'en-us': 'In what town was your first job?',
      'fr': 'Dans quelle ville était votre premier emploi ?'
    },
    {
      'en-us': 'What was the name of the company where you had your first job?',
      'fr': "Quel était le nom de l'entreprise où vous avez eu votre premier emploi ?"
    }
  ]

  public static STATUS_UPDATE = {
    'en-us': 'Status Update',
    'fr': 'Mise à jour du statut'
  };

  public static LANGUAGES = {
    ENGLISH: 'en-us',
    FRENCH: 'fr',
    SPANISH: 'es',
    'en-us': 'English',
    fr: 'French',
    es: 'Spanish',
  };
  public static PHONEFORMAT = {
    US: { FORMATTEDLENGTH: '14' },
    CA: { FORMATTEDLENGTH: '14' },
    MX: { FORMATTEDLENGTH: '12' },
    CL: { FORMATTEDLENGTH: '11' },
    CO: { FORMATTEDLENGTH: '11' },
    CR: { FORMATTEDLENGTH: '9' },
    DO: { FORMATTEDLENGTH: '14' },
    EC: { FORMATTEDLENGTH: '9' },
    SV: { FORMATTEDLENGTH: '9' },
    GT: { FORMATTEDLENGTH: '9' },
    HT: { FORMATTEDLENGTH: '10' },
    HN: { FORMATTEDLENGTH: '9' },
    IN: { FORMATTEDLENGTH: '12' },
    JM: { FORMATTEDLENGTH: '14' },
    NI: { FORMATTEDLENGTH: '9' },
    PA: { FORMATTEDLENGTH: '9' },
    PE: { FORMATTEDLENGTH: '11' },
    PR: { FORMATTEDLENGTH: '14' },
    TT: { FORMATTEDLENGTH: '14' },
    VN: { FORMATTEDLENGTH: '12' },
    KY: { FORMATTEDLENGTH: '14' },
    BO: { FORMATTEDLENGTH: '8' },
    BZ: { FORMATTEDLENGTH: '8' },
    AW: { FORMATTEDLENGTH: '8' },
    BS: { FORMATTEDLENGTH: '14' },
    BB: { FORMATTEDLENGTH: '14' },
    BQ: { FORMATTEDLENGTH: '8' },
    CW: { FORMATTEDLENGTH: '10' },
    SX: { FORMATTEDLENGTH: '14' },
    GY: { FORMATTEDLENGTH: '8' },
    LC: { FORMATTEDLENGTH: '14' },
    VI: { FORMATTEDLENGTH: '14' },
    AR: { FORMATTEDLENGTH: '11' },
    UY: { FORMATTEDLENGTH: '8' }
  };
  public static MEDIUM_TYPES = {
    PHONE: 'phone',
    EMAIL: 'email',
  };
  public static CODE_TYPES = {
    DELETE: 'deletion',
    REGISTER: 'registration',
    LOGIN: 'login',
  };
  public static KWIKSET = {
    HELP_FAQ: 'https://www.kwikset.com/mobile/smartlocks',
    ToS: 'https://www.kwikset.com/smart-locks/eula',
    ToU: 'https://www.privacy.assaabloydss.com/en/assa-abloy-terms-of-use',
    PP: 'https://www.privacy.assaabloydss.com/en/privacy',
    defaultCountryCode: 'US'
  };
  public static WEISER = {
    ToS: 'https://www.weiserlock.com/en/smart-locks/eula',
    HELP_FAQ: 'https://www.weiserlock.com/en/mobile/smartlocks',
    ToU: 'https://ca.weiserlock.com/fr/conditions-d-utilisation',
    PP: 'https://ca.weiserlock.com/fr/politique-de-confidentialite',
    defaultCountryCode: 'CA'
  };
  public static USER = {
    IMAGE_SIZE: 25, // add number in MegaBytes
    ALLOWED_FORMATS: ['jpg', 'jpeg', 'png'],
    UPLOADED_IMAGE_DEFAULT_BYTECOUNT: 2, //number in MegaBytes
  };

  public static FEDERATED_IDENTITIES = {
    Google: 'Google',
    Apple: 'SignInWithApple'
  };

  public static PROVIDERS = {
    'SIMPLE': 'SIMPLE',
    'FEDERATED': 'FEDERATED'
  };

  public static USER_BRANDS = {
    KWIKSET: 'KWIKSET',
    WEISER: 'WEISER'
  };

  public static LINKS = {
    EMAIL: "AMERRes.OnlineSystems@assaabloy.com"
  }
  public static COOKIE_MAX_AGE = 60 * 60 * 24 * 90;
  public static UPDATE_STATUS_SECONDS = 6400;
  public static DEFAULT_PAGE_NO = 1;
  public static DATE_START_TIME = { HOUR: 0, MIN: 0, SEC: 0 };
  public static DATE_END_TIME = { HOUR: 23, MIN: 59, SEC: 59 };
  public static FLAG_ASSET_DIR = 'assets/images/flags/';
}
